import { baseUrl } from "./baseUrl";

// export const updateTariffication = () =>
//   [`${baseUrl}`, "pre-processor-api", "preprocessor/reprocess-unknown"].join("/");

export const updateTariffication = () =>
  [`${baseUrl}`, "pre-processor-api", "pre-billing/reprocess"].join("/");

// export const checkProcessingRoute = () =>
//   [`${baseUrl}`, "pre-processor-api", "preprocessor", "check"].join("/");

// export const reprocessRoute = () =>
//   [`${baseUrl}`, "pre-processor-api", "preprocessor", "reprocess"].join("/");

export const reprocessPrebillingRoute = () =>
  [`${baseUrl}`, "pre-processor-api", "pre-billing", "reprocess"].join("/");
